export default function KCImage({ children, ...attributes }) {
    return (
        <img {...attributes} />
    );
}